import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import PdfEditor from '../../PdfEditor';
import CloseIcon from '../../Icons/Close';
import './PdfEditorModal.scss';

const MODAL_STYLE = {
  content: {
    margin: '0 auto',
    maxWidth: '70%',
    position: 'relative',
    height: '90%',
    padding: 0,
  },
};
function PdfEditorModal({ url, onClose, ...props }) {
  const [canCloseModal, setCanCloseModal] = useState(true);
  const modalOnClose = canCloseModal ? onClose : () => {};
  return (
    <Modal isOpen={!!url} style={MODAL_STYLE} {...props}>
      <CloseIcon onClick={modalOnClose} />
      <div className="pdf-container">
        <PdfEditor
          document={url}
          setCanCloseModal={setCanCloseModal}
          {...props}
        />
      </div>
    </Modal>
  );
}

PdfEditorModal.propTypes = {
  url: PropTypes.string,
  onClose: PropTypes.func,
};

export default PdfEditorModal;
